/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SystemFunctionViewModel } from '../model/systemFunctionViewModel';
import { SystemGroupInfoViewModel } from '../model/systemGroupInfoViewModel';
import { SystemViewModel } from '../model/systemViewModel';
import { ToDoListViewModel } from '../model/toDoListViewModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserProfileService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [Public] 取得 指定使用者 及 指定公司 之 所有系統別
     * 
     * @param userNo 
     * @param companyId 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileUserNoCompanyCompanyIdSystemsGet(userNo: string, companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SystemViewModel>>;
    public rbacUserProfileUserNoCompanyCompanyIdSystemsGet(userNo: string, companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SystemViewModel>>>;
    public rbacUserProfileUserNoCompanyCompanyIdSystemsGet(userNo: string, companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SystemViewModel>>>;
    public rbacUserProfileUserNoCompanyCompanyIdSystemsGet(userNo: string, companyId: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserProfileUserNoCompanyCompanyIdSystemsGet.');
        }

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling rbacUserProfileUserNoCompanyCompanyIdSystemsGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SystemViewModel>>('get',`${this.basePath}/Rbac/UserProfile/${encodeURIComponent(String(userNo))}/Company/${encodeURIComponent(String(companyId))}/Systems`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 取得 指定使用者 及 指定公司 及 指定系統別 之 所有功能別
     * 
     * @param userNo 
     * @param companyId 
     * @param systemId 
     * @param limitProcess 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdSystemFunctionsGet(userNo: string, companyId: number, systemId: number, limitProcess?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SystemFunctionViewModel>>;
    public rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdSystemFunctionsGet(userNo: string, companyId: number, systemId: number, limitProcess?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SystemFunctionViewModel>>>;
    public rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdSystemFunctionsGet(userNo: string, companyId: number, systemId: number, limitProcess?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SystemFunctionViewModel>>>;
    public rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdSystemFunctionsGet(userNo: string, companyId: number, systemId: number, limitProcess?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdSystemFunctionsGet.');
        }

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdSystemFunctionsGet.');
        }

        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdSystemFunctionsGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (limitProcess !== undefined && limitProcess !== null) {
            queryParameters = queryParameters.set('limitProcess', <any>limitProcess);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SystemFunctionViewModel>>('get',`${this.basePath}/Rbac/UserProfile/${encodeURIComponent(String(userNo))}/Company/${encodeURIComponent(String(companyId))}/Systems/${encodeURIComponent(String(systemId))}/SystemFunctions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 取得 指定使用者 及 指定公司 及 指定系統別 之 代辦清單
     * 
     * @param userNo 使用者代號
     * @param companyId 公司代號
     * @param systemId 系統代號
     * @param isSubstitution 是否代理
     * @param environmemt 環境(內網:0, 外網:1)(預設:0)
     * @param filterMultipleRole 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdToDoListsGet(userNo: string, companyId: number, systemId: number, isSubstitution?: boolean, environmemt?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ToDoListViewModel>>;
    public rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdToDoListsGet(userNo: string, companyId: number, systemId: number, isSubstitution?: boolean, environmemt?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ToDoListViewModel>>>;
    public rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdToDoListsGet(userNo: string, companyId: number, systemId: number, isSubstitution?: boolean, environmemt?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ToDoListViewModel>>>;
    public rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdToDoListsGet(userNo: string, companyId: number, systemId: number, isSubstitution?: boolean, environmemt?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdToDoListsGet.');
        }

        if (companyId === null || companyId === undefined) {
            throw new Error('Required parameter companyId was null or undefined when calling rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdToDoListsGet.');
        }

        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling rbacUserProfileUserNoCompanyCompanyIdSystemsSystemIdToDoListsGet.');
        }








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isSubstitution !== undefined && isSubstitution !== null) {
            queryParameters = queryParameters.set('isSubstitution', <any>isSubstitution);
        }
        if (environmemt !== undefined && environmemt !== null) {
            queryParameters = queryParameters.set('environmemt', <any>environmemt);
        }
        if (filterMultipleRole !== undefined && filterMultipleRole !== null) {
            queryParameters = queryParameters.set('filterMultipleRole', <any>filterMultipleRole);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ToDoListViewModel>>('get',`${this.basePath}/Rbac/UserProfile/${encodeURIComponent(String(userNo))}/Company/${encodeURIComponent(String(companyId))}/Systems/${encodeURIComponent(String(systemId))}/ToDoLists`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 取得 指定使用者 之 所有角色代碼
     * 
     * @param userNo 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileUserNoRoleCodesGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public rbacUserProfileUserNoRoleCodesGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public rbacUserProfileUserNoRoleCodesGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public rbacUserProfileUserNoRoleCodesGet(userNo: string, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserProfileUserNoRoleCodesGet.');
        }





        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<string>>('get',`${this.basePath}/Rbac/UserProfile/${encodeURIComponent(String(userNo))}/RoleCodes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 取得 指定使用者之 所有系統別(portal)
     * 
     * @param userNo 
     * @param environment 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileUserNoSystemGroupInfosGet(userNo: string, environment?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SystemGroupInfoViewModel>>;
    public rbacUserProfileUserNoSystemGroupInfosGet(userNo: string, environment?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SystemGroupInfoViewModel>>>;
    public rbacUserProfileUserNoSystemGroupInfosGet(userNo: string, environment?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SystemGroupInfoViewModel>>>;
    public rbacUserProfileUserNoSystemGroupInfosGet(userNo: string, environment?: number, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserProfileUserNoSystemGroupInfosGet.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (environment !== undefined && environment !== null) {
            queryParameters = queryParameters.set('environment', <any>environment);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SystemGroupInfoViewModel>>('get',`${this.basePath}/Rbac/UserProfile/${encodeURIComponent(String(userNo))}/SystemGroupInfos`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Public] 取得 指定使用者 之 代辦清單
     * 
     * @param userNo 使用者代號
     * @param isSubstitution 是否代理
     * @param environmemt 環境(內網:0, 外網:1)(預設:0)
     * @param filterMultipleRole 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rbacUserProfileUserNoToDoListsGet(userNo: string, isSubstitution?: boolean, environmemt?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ToDoListViewModel>>;
    public rbacUserProfileUserNoToDoListsGet(userNo: string, isSubstitution?: boolean, environmemt?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ToDoListViewModel>>>;
    public rbacUserProfileUserNoToDoListsGet(userNo: string, isSubstitution?: boolean, environmemt?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ToDoListViewModel>>>;
    public rbacUserProfileUserNoToDoListsGet(userNo: string, isSubstitution?: boolean, environmemt?: number, filterMultipleRole?: boolean, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userNo === null || userNo === undefined) {
            throw new Error('Required parameter userNo was null or undefined when calling rbacUserProfileUserNoToDoListsGet.');
        }








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isSubstitution !== undefined && isSubstitution !== null) {
            queryParameters = queryParameters.set('isSubstitution', <any>isSubstitution);
        }
        if (environmemt !== undefined && environmemt !== null) {
            queryParameters = queryParameters.set('environmemt', <any>environmemt);
        }
        if (filterMultipleRole !== undefined && filterMultipleRole !== null) {
            queryParameters = queryParameters.set('filterMultipleRole', <any>filterMultipleRole);
        }

        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ToDoListViewModel>>('get',`${this.basePath}/Rbac/UserProfile/${encodeURIComponent(String(userNo))}/ToDoLists`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
